<template>
    <div id="services" class="hero">
        <div class="container">

            <!-- Slider main container -->
            <div class="swiper-container-services">
                <!-- Additional required wrapper -->
                <div class="swiper-wrapper">
                    <!-- Slides -->

                   <div v-if="columns" class="swiper-slide" v-for="slide in Math.ceil(columns.length/3)">
                        <div class="columns">
                            <div class="column is-one-third" v-for="column in 3">

                               <p v-if="shouldDisplay(column, slide)" class="f-services-maingroup">{{columns[((slide-1)*3)+column -1].title}}</p>
                               <p v-else class="f-services-maingroup"> &nbsp;</p>
                               <ul>
                                    <li class="f-services-subgroup" v-for="ro in 10">
                                        {{ columnRow(column, slide, ro) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>

            </div>

        </div>
    </div>
</template>

<script>
//import Swiper from 'swiper';
import columns from "../plugins/columns";
import { apiUrl } from "../vars";

export default {
  data() {
    return {
      columns: []
    };
  },

  created() {
    this.initialize();
  },

  mounted() {},

  methods: {
    initialize() {
      axios.get(apiUrl + "/api/site/columns").then(r  => {
        this.columns = r.data;
        let swiper = new Swiper(".swiper-container-services", {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        });
      });
    },

    shouldDisplay(column, slide) {
      if (this.columns[(slide - 1) * 3 + column - 1]) {
        return (
          column == 1 ||
          this.columns[(slide - 1) * 3 + column - 1]["title"] !=
            this.columns[(slide - 1) * 3 + column - 2]["title"]
        );
      }
    },

    columnRow(column, slide, ro) {
      let columns = {};
      Object.assign(columns, this.columns);

      if (this.columns[(slide - 1) * 3 + column - 1]) {
        if (ro <= columns[(slide - 1) * 3 + column - 1]["rows"].length) {
          return columns[(slide - 1) * 3 + column - 1]["rows"][ro - 1];
        }
      }
    }
  }
};
</script>

<style scoped>
.column {
  margin: 1rem;
  flex: unset;
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
}

.container {
  min-height: 18rem;
  overflow: hidden;
}

.hero {
  padding: 2rem 0 2rem;
  background-color: #d8d8d8;
}

.f-services-maingroup {
  color: #5f5f5f;
  font-weight: 700;
  font-size: 1.1rem;
  line-height: 1.1;
  height: 4rem;
}

.f-services-subgroup {
  color: #5f5f5f;
  font-weight: 400;
  font-size: 1.02rem;
  line-height: 1.2;
}

.columns {
  padding: 0 6rem;
}

.swiper-button-next {
  background-image: url("/static/images/layout/right.svg") !important;
}

.swiper-button-prev {
  background-image: url("/static/images/layout/left.svg") !important;
}

.swiper-button-next {
  position: absolute;
  //top:45%;
}
.swiper-button-prev {
  position: absolute;
  //top:45%;
}

@media only screen and (min-width: 1408px) {
}
@media only screen and (min-width: 1216px) and (max-width: 1407px) {
}
@media only screen and (min-width: 1024px) and (max-width: 1215px) {
}
@media only screen and (min-width: 769px) and (max-width: 1023px) {
  .swiper-button-next {
    position: absolute;
    right: 0;
  }
  .column {
    width: 22vw !important;
  }
}

@media only screen and (min-width: 769px) {
}

@media only screen and (max-width: 768px) {
  .swiper-button-next {
    position: absolute;
    left: 90vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Services.vue